/**
 * Provider modes served by `GET /api/notifications_v2/config`. Registration may happen on both
 * providers at once; delivery of a given notification happens on exactly one. The site no longer
 * ships the OneSignal SDK, so only a brand on `fcm_delivery` gets push on it: the OneSignal modes
 * still decide the inbox (V1) and whether the FCM endpoint is registered, but deliver nothing here.
 */
export const PROVIDER_MODES = Object.freeze({
  ONESIGNAL_ONLY: 'onesignal_only',
  DUAL_REGISTRATION: 'onesignal_delivery_fcm_registration',
  FCM_DELIVERY: 'fcm_delivery',
});

export const registersFcm = mode =>
  mode === PROVIDER_MODES.DUAL_REGISTRATION ||
  mode === PROVIDER_MODES.FCM_DELIVERY;

export const deliversWithFcm = mode => mode === PROVIDER_MODES.FCM_DELIVERY;

/**
 * This site registers a `web` endpoint only when the brand registers FCM endpoints, the engine
 * accepts registrations, the `web` channel is on and the public Firebase config and VAPID key are
 * there to ask for a token with.
 */
export const registersWeb = config =>
  !!config?.enabled &&
  config.registration_enabled !== false &&
  registersFcm(config.provider_mode) &&
  (config.channels || []).includes('web') &&
  !!config.firebase?.web_config &&
  !!config.firebase?.vapid_public_key;
